<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      User Edit
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          
          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Fullname" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Fullname
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : John Doe"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.full_name"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>

                          <ValidationProvider 
                            name="Role" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Role
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : News"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                              
                              :items="[
                                {
                                  text: 'Admin',
                                  value: 'admin'
                                },
                                {
                                  text: 'Admin TV',
                                  value: 'admin_tv'
                                }
                              ]"
                              item-text="text"
                              item-value="value"
                              :item-color="set_color"
                              
                              clearable
                              @click:clear="form.role = ''"
                              
                              v-model="form.role"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-select>
                          </ValidationProvider>

                          <div>
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Tanggal Join
                            </div>

                            <v-menu
                              ref="picker"
                              min-width="290px"
                              max-width="290px"
                              transition="scale-transition"
                              offset-y
                              :nudge-right="40"
                              :close-on-content-click="false"
                              v-model="picker">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  name="Tanggal Join" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    readonly
                                    filled
                                    rounded
                                    dense

                                    :color="set_color"
                                    placeholder="Ex : 2023-12-01"
                                    :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                    clearable
                                    @click:clear="form.join_date = ''"

                                    v-on="on"
                                    v-bind="attrs"

                                    v-model="form.join_date"
                                    :success="valid"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-date-picker 
                                :color="set_color"
                                v-model="form.join_date"
                                @input="picker = false">
                              </v-date-picker>
                            </v-menu>
                          </div>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Email" 
                            rules="required|email" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Email
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : johndoe@gmail.com"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.email"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>

                          <ValidationProvider 
                            name="Status" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Status
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : Active"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                              
                              :items="[
                                {
                                  text: 'Active',
                                  value: true
                                },
                                {
                                  text: 'Not Active',
                                  value: false
                                }
                              ]"
                              item-text="text"
                              item-value="value"
                              :item-color="set_color"
                              
                              clearable
                              @click:clear="form.is_active_bool = ''"
                              
                              v-model="form.is_active_bool"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="2"
              class="py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize"
                style="border-radius: 8px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        show: false,

        form: {
          id: '',
          full_name: '',
          email: '',
          password: '',
          role: '',
          join_date: '',
          is_active_bool: ''
        },

        picker: false,

        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        let params = {
          id: this.$route.params.id
        }

        await get(`admin/user/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.form = res.result
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/user/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.$router.push('/setting/user')
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>